module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@2x-0627c3a1910f07801e21e33c38890782.png";